var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerTrial"},[_c('span',[_vm._v("Bạn đang ở chế độ chơi thử")]),_c('span',{staticClass:"btnExit",on:{"click":function($event){return _vm.setModalConfirmPlayTrial(true)}}},[_vm._v(" Thoát ")])])}
var staticRenderFns = []

export { render, staticRenderFns }